import { TarefaContextProvider } from "../../context/tarefa.service";
import { TarefasLista } from "./tarefas-lista";

export const Tarefas = () => {

    return <TarefaContextProvider>
      <TarefasLista />
    </TarefaContextProvider>
}
